<ng-container *ngIf="isProductionScheduleDisplayOverview">
  <svg:svg
    #productionScheduleItemInPathGroup
    app-production-schedule-item-in-path-group-new
    [isProductionScheduleItemInPathGroupRepetition]="false"
    [productionScheduleItem]="productionScheduleItem"
    [productionScheduleColoredYarnSet]="productionScheduleColoredYarnSet"
    [cutbarBeforeHeight]="cutbarBeforeHeight"
    [cutbarAfterHeight]="cutbarAfterHeight"
    [drawingHeight]="drawingHeight"
    [drawingImageHeight]="drawingImageHeight"
    [drawingWidth]="drawingWidth"
    [totalHeight]="totalHeight"
  ></svg:svg>
  <svg:svg
    *ngIf="canShowRepeatIndicator()"
    app-production-schedule-item-in-path-group-repeat-indicator-new
    y="0"
    [quantity]="productionScheduleItem.quantity"
    [productionScheduleItemMultiplier]="productionSchedule.getProductionScheduleItemMultiplier()"
    [drawingWidth]="drawingWidth"
  ></svg:svg>
</ng-container>
